<template>
  <p>
    Return to
    <BaseLinkOpenNew url="https://dmv.ri.gov/online-services" name="RI DMV Online Services" />
  </p>
</template>


<script setup>
import BaseLinkOpenNew from "./ui/BaseLinkOpenNew";

defineOptions({
  name: 'RiDmvHome'
});
</script>
